import PartsAppPartOrdered from "./PartsAppPart";

export interface Preferences {
  id: number;
  userId: string;
  companyId: number;
  currentDepotId: string;
  preferExternalScanner: boolean;
  recentParts: PartsAppPartOrdered[];
}

export const defaultPrefs: Preferences = {
  id: 0,
  userId: "",
  companyId: 0,
  currentDepotId: "",
  preferExternalScanner: false,
  recentParts: [],
};
